<template>
  <div class="workflow-options">
    <label class="workflow-option" :class="{ active: modelValue === 'standard' }">
      <div class="workflow-option-radio">
        <input
          :checked="modelValue === 'standard'"
          type="radio"
          value="standard"
          :disabled="disabled"
          @change="$emit('update:modelValue', 'standard')"
        />
      </div>
      <div class="workflow-option-content">
        <div class="workflow-option-title">
          {{ s__(`${translationNamespace}|Standard Workflow`) }}
        </div>
        <div class="workflow-option-description">
          {{ s__(`${translationNamespace}|To Do, In Progress, Need Info, Done, Cancelled`) }}
        </div>
      </div>
    </label>
    <label class="workflow-option" :class="{ active: modelValue === 'simplified' }">
      <div class="workflow-option-radio">
        <input
          :checked="modelValue === 'simplified'"
          type="radio"
          value="simplified"
          :disabled="disabled"
          @change="$emit('update:modelValue', 'simplified')"
        />
      </div>
      <div class="workflow-option-content">
        <div class="workflow-option-title">
          {{ s__(`${translationNamespace}|Simplified Workflow`) }}
        </div>
        <div class="workflow-option-description">
          {{ s__(`${translationNamespace}|To Be Done, Done`) }}
        </div>
      </div>
    </label>
  </div>
</template>

<script setup>
import { s__ } from '@/locale'

defineProps({
  modelValue: {
    type: String,
    required: true,
    validator: value => ['standard', 'simplified'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  translationNamespace: {
    type: String,
    required: true,
    validator: value => ['Project', 'PersonalProject'].includes(value),
  },
})

defineEmits(['update:modelValue'])
</script>

<style scoped>
.workflow-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.workflow-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
}

.workflow-option:hover:not(:has(input:disabled)) {
  border-color: #1d6bf3;
  background-color: #f8f9ff;
}

.workflow-option.active {
  border-color: #1d6bf3;
  background-color: #e7f3ff4b;
}

.workflow-option:has(input:disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}

.workflow-option-radio {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 20px; /* Match title line height */
}

.workflow-option input[type='radio'] {
  margin: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
  accent-color: #2aabee;
}

.workflow-option input[type='radio']:disabled {
  cursor: not-allowed;
}

.workflow-option-content {
  flex: 1;
}

.workflow-option-title {
  font-weight: 600;
  font-size: 15px;
  color: #212529;
  margin-bottom: 4px;
  line-height: 20px; /* Match radio button height */
}

.workflow-option-description {
  font-size: 13px;
  color: #6c757d;
}
</style>
